import { GenericOperationState } from '@repo/core'
import { FundScreenerSessionResponse } from '@repo/tools-types'
import { RootState } from '../../store/types'

export const fundScreenerSessionDataSelectorConfig = {
  fundScreenerSessionDataSelector: {
    getRootPath: function (
      state: RootState,
    ): GenericOperationState<FundScreenerSessionResponse | null> {
      return state.tools.fundScreener.session
    },
  },
}
